(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-status-log', {
            parent: 'entity',
            url: '/customer-status-log?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.customerStatusLog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-status-log/customer-status-logs.html',
                    controller: 'CustomerStatusLogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                phone: null,
                status: null,
                changeReason: ''
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        phone: $stateParams.phone,
                        status: $stateParams.status,
                        changeReason: $stateParams.changeReason
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
